export default __webpack_public_path__ + "static/media/34.8345488b.jpg";